import { createFileRoute } from '@tanstack/react-router'

import CertificatesOverview from '@/certificates/components/CertificatesOverview/CertificatesOverview'
import { buildPageTitle } from '@/core/utils/buildPageTitle/buildPageTitle'

export const Route = createFileRoute('/_learning/_my-learning/certificates')({
  head: () => ({
    meta: [
      {
        title: buildPageTitle({
          titleKey: 'page-title-my-certificates',
        }),
      },
    ],
  }),
  component: CertificatesOverview,
})
